import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, FinalFormInput, FormContainer } from '@utex/ui-kit';
import { CommissionNote } from '../../../components/CommissionNote';
import { Layout } from '../../../components/Layout';
import { Instrument } from '../../../hooks/mapInstruments';
import { useFormProps } from './hooks';
import { AmountInput } from '../../../components/AmountInput';
import { FormError } from '../../../components/FormError';

export interface FormValues {
  amount: number;
  address: string;
}

export const Content: React.FC<Instrument> = (props) => {
  const { t } = useTranslation('toUTT');

  const { commission, currency } = props;
  const { validate, onSubmit } = useFormProps(props);

  return (
    <FormContainer<FormValues>
      onSubmit={onSubmit}
      validate={validate}
      render={({ values: { amount }, handleSubmit, submitError, submitting }) => (
        <Layout.Form onSubmit={handleSubmit} noValidate>
          <Layout.FormContent>
            <Box display="flex" flexDirection="column">
              <AmountInput isLabelShort={false} currency={currency} />
              <FinalFormInput
                name="address"
                id="address"
                type="text"
                label={t('Wallet')}
                isLabelAboveValueOnMobile
                view="medium"
                hintPosition="right"
              />
            </Box>
          </Layout.FormContent>
          <FormError>{submitError}</FormError>
          <Layout.FormFooter>
            <Button view="alert" type="submit" isLoading={submitting}>
              {t('Continue')}
            </Button>
            <CommissionNote
              commission={commission}
              amount={{ value: amount || 0, currency }}
              caption={t('To be credited to the wallet')}
              isReverse={false}
            />
          </Layout.FormFooter>
        </Layout.Form>
      )}
    />
  );
};
